import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Div, OverflowMenu } from '@gaiads/telia-react-component-library';

import { OrganizationWithUserGroupsResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';
import { routes, withCustomerOrgFormPath } from '../App/routes';
import { selectOrganization } from '../../store/order';

const OrganizationMenu = () => {
  const organization: OrganizationWithUserGroupsResponse | null = useSelector(selectOrganization);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('sideNavigation');
  const history = useHistory();

  return (
    <Div padding={{ top: 'md', bottom: 'lg', left: 'sm' }}>
      <OverflowMenu onClick={() => setOpen(!open)} open={open}>
        <OverflowMenu.Item
          onClick={() => history.push(withCustomerOrgFormPath(routes.companyInformation, organization?.id))}
          iconName="premises"
          label={t('companyInformation')}
          variant={'active'}
        />
        <OverflowMenu.Item
          onClick={() => history.push(withCustomerOrgFormPath(routes.orders, organization?.id))}
          iconName="delivery"
          label={t('orders')}
          variant={'active'}
        />
        <OverflowMenu.Item
          onClick={() => history.push(withCustomerOrgFormPath(routes.devices, organization?.id))}
          iconName="smartphone"
          label={t('devices')}
          variant={'active'}
        />
        <OverflowMenu.Item
          onClick={() => history.push(withCustomerOrgFormPath(routes.users, organization?.id))}
          iconName="end-user"
          label={t('users')}
          variant={'active'}
        />
        <OverflowMenu.Item
          onClick={() => history.push(withCustomerOrgFormPath(routes.userGroups, organization?.id))}
          iconName="people"
          label={t('userGroups')}
          variant={'active'}
        />
      </OverflowMenu>
    </Div>
  );
};

export default OrganizationMenu;
